import angular from 'angular';

export default function EditGeneratedReportsDialogController(
  $rootScope,
  $scope,
  $q,
  $filter,
  ssDialogService,
  loaderService,
  alerts,
  docDataService,
  reportsDataService,
  selectEditTypeDialog,
) {
  const vm = this;

  vm.canExpand = vm.status !== 'No Folder Added';
  vm.isReportsExpanded = true;
  vm.itemsLoaded = false;

  vm.handleGoBack = _handleGoBack;
  vm.handleCloseDialog = _handleCloseDialog;

  _activate();

  // //////// METHODS //////////

  function _activate() {
    loaderService.showViewLoader = true;
    const dfdActivate = $q.defer();

    _loadReportInstances().then(() => {
      vm.itemsLoaded = true;
      dfdActivate.resolve();
      loaderService.showViewLoader = false;
    });

    return dfdActivate.promise;
  }

  function _handleGoBack($event) {
    ssDialogService.hide(ssDialogService.dialogs.reports.editReportPackageDialog);
    
    ssDialogService.dialogs.reports.selectEditTypeDialog = ssDialogService.alert(
      selectEditTypeDialog.getOptions($event, {
        hasAdvisoryServices: vm.hasAdvisoryServices,
        reportPackage: vm.reportPackage,
        selectedEditTypeId: 2,
        attachCallback: vm.documentAttached,
      }),
    );
    return ssDialogService.show(ssDialogService.dialogs.reports.selectEditTypeDialog);
  }

  function _handleCloseDialog() {
    $rootScope.$broadcast('refreshReportPackageConfiguration', {
      reportPackageId: Number(vm.reportPackage.reportPackageId),
    });
    ssDialogService.hide(ssDialogService.dialogs.reports.editReportPackageDialog);
  }

  function _loadReportInstances() {
    loaderService.showViewLoader = true;
    const dfdRefresh = $q.defer();

    const dfdFinancialInstitutionReports = docDataService.getCustomerReportInstances();
    const dfdMyReports = docDataService.getUserReportInstances();
    const dfdArchivedReports = docDataService.getArchivedReportInstances();

    $q.all([dfdFinancialInstitutionReports, dfdMyReports, dfdArchivedReports]).then(responses => {
      vm.fiReportFolders = responses[0].data;
      vm.myReportFolders = responses[1].data;
      vm.archivedReportFolders = responses[2].data;
      loaderService.showViewLoader = false;
      dfdRefresh.resolve();
    });

    return dfdRefresh.promise;
  }
}

EditGeneratedReportsDialogController.$inject = [
  '$rootScope',
  '$scope',
  '$q',
  '$filter',
  'ssDialogService',
  'loaderService',
  'alerts',
  'docDataService',
  'reportsDataService',
  'selectEditTypeDialog',
];
